var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// fonts.ts
import "@adornis/ass";
import { customElement } from "lit/decorators.js";
import { fontReset, FontResetElement } from "./font-resets";
var ElementsH1 = class extends FontResetElement {
  styles() {
    return [
      fontReset(this.fontFamily, 2, 900, 1.4, this.baseFontSize),
      {
        "@media print": fontReset(this.fontFamily, 2, 900, 1, this.baseFontSizePrint)
      }
    ];
  }
};
ElementsH1 = __decorateClass([
  customElement("x-h1")
], ElementsH1);
var ElementsH2 = class extends FontResetElement {
  styles() {
    return [
      fontReset(this.fontFamily, 1.5, 900, 1.4, this.baseFontSize),
      {
        "@media print": fontReset(this.fontFamily, 1.5, 900, 1, this.baseFontSizePrint)
      }
    ];
  }
};
ElementsH2 = __decorateClass([
  customElement("x-h2")
], ElementsH2);
var ElementsH3 = class extends FontResetElement {
  styles() {
    return [
      fontReset(this.fontFamily, 1.2, 900, 1.4, this.baseFontSize),
      {
        "@media print": fontReset(this.fontFamily, 1.2, 900, 1, this.baseFontSizePrint)
      }
    ];
  }
};
ElementsH3 = __decorateClass([
  customElement("x-h3")
], ElementsH3);
var ElementsH4 = class extends FontResetElement {
  styles() {
    return [
      fontReset(this.fontFamily, 1.1, 900, 1.4, this.baseFontSize),
      {
        "@media print": fontReset(this.fontFamily, 1.1, 900, 1, this.baseFontSizePrint)
      }
    ];
  }
};
ElementsH4 = __decorateClass([
  customElement("x-h4")
], ElementsH4);
var ElementsText = class extends FontResetElement {
  styles() {
    return [
      fontReset(this.fontFamily, 1, 400, 1.2, this.baseFontSize),
      {
        "@media print": fontReset(this.fontFamily, 1, 400, 1.2, this.baseFontSizePrint),
        "&[bold]": { fontWeight: "bold" },
        "&[italic]": { fontStyle: "italic" },
        "&[tone=subtle]": { color: this.colors.neutral_700 },
        "&[tone=success]": { color: this.colors.tone.success },
        "&[tone=warning]": { color: this.colors.tone.warning },
        "&[tone=error]": { color: this.colors.tone.error }
      }
    ];
  }
};
ElementsText = __decorateClass([
  customElement("x-text")
], ElementsText);
export {
  ElementsH1,
  ElementsH2,
  ElementsH3,
  ElementsH4,
  ElementsText
};
